import { Box, SelectOption } from "@nulogy/components";
import Select from "components/controls/Select";
import React from "react";
import styled from "styled-components";
import LineStatusIndicator from "./LineStatusIndicator";

const StyledBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.sizes.x1,
  width: "184px",
}));

const CustomOption = ({ children, ...props }) => (
  <SelectOption {...props} className={`spec-line-${children}`}>
    <LineStatusIndicator label={children} />
  </SelectOption>
);

const CustomSingleValue = ({ children }) => <LineStatusIndicator label={children} />;

export default function LineStatusSelect() {
  return (
    <StyledBox>
      <Select
        className="spec-line-status-select"
        components={{
          Option: CustomOption,
          SingleValue: CustomSingleValue,
        }}
        field="active"
        maxHeight="250"
        options={[
          { label: "Active", value: true },
          { label: "Inactive", value: false },
        ]}
      />
    </StyledBox>
  );
}
